import { Component, EventEmitter, Input, OnInit, Output, TemplateRef } from '@angular/core';
import { IconComponent } from '../icon/icon.component';

type ToastTypes = 'basic' | 'primary';
type ToastSeverity = 'primary' | 'secondary' | 'success' | 'info' | 'warning' | 'danger' | 'default';

@Component({
    selector: 'fk-toast',
    templateUrl: './toast.component.html',
    styleUrls: ['./toast.component.scss'],
    imports: [IconComponent,]
})
export class ToastComponent implements OnInit {
  @Input()
  public type: ToastTypes = 'basic';

  @Input()
  public severity: ToastSeverity = 'default';

  @Input()
  public icon?: string;

  @Input()
  public title: string = '';

  @Input()
  public text: string = '';

  @Input()
  public textTpl!: TemplateRef<any>;

  @Input()
  public closeable: boolean = true;

  @Input()
  public liveTime: number = 0;

  @Output()
  public closed: EventEmitter<boolean> = new EventEmitter<boolean>();

  public ngOnInit(): void {
    if (this.liveTime) {
      setTimeout(() => {
        this.onClose();
      }, this.liveTime);
    }
  }

  protected getToastCls(): string {
    if (this.type === 'basic') return 'fk-toast-basic';

    return `fk-toast-${this.severity}`;
  }

  protected getIconCls(): string {
    return `fk-toast__icon-${this.severity}`;
  }

  protected getIconName(): string {
    if (this.icon) return this.icon;

    const iconMap: Record<ToastSeverity, string> = {
      primary: 'info',
      secondary: 'settings',
      info: 'question-circle',
      success: 'check-circle',
      warning: 'alert-triangle',
      danger: 'x-circle',
      default: 'star',
    };

    return iconMap[this.severity];
  }

  protected onClose(): void {
    this.closed.emit(true);
  }
}
